const Header = () => {
    return (
        <header>
            <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
                <div className="container-fluid" style={{ backgroundColor: "#EF4923", padding: 0, margin: 0 }}>
                    <a className="navbar-brand mx-3" asp-area="" asp-page="/Index">
                        <img src="https://ketquaxettuyen.viendong.edu.vn/LogoVD.ico" width="40" height="40" />
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".navbar-collapse" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between">
                        <ul className="navbar-nav flex-grow-1">
                            <li className="nav-item">
                                <a className="nav-link text-dark" href="https://www.viendong.edu.vn/g1-gioi-thieu.html"><p className="m-0 text-white">GIỚI THIỆU</p></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-dark" href="https://www.viendong.edu.vn/ho-tro-sinh-vien.html"><p className="m-0 text-white">HỖ TRỢ SINH VIÊN</p></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-dark" href="https://www.viendong.edu.vn/danh-muc-ho-tro/hoat-dong-cuu-sv"><p className="m-0 text-white">CỰU SINH VIÊN</p></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-dark" href="https://www.viendong.edu.vn/category/hoat-dong/hoat-dong-cua-doan-the"><p className="m-0 text-white">ĐẢNG - ĐOÀN THỂ</p></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    )
}

export default Header;